<template>
  <div :class="$style['basket-buttons']">
    <div v-show="showClose" @click="closeBasket">
      <BaseButton :class="$style['basket-btn']" type="secondary">{{
        $t('checkout.basket.close')
      }}</BaseButton>
    </div>
    <v-btn
      class="btn"
      :class="$style['basket-btn']"
      color="primary"
      :disabled="pending"
      rounded
      @click="goToCheckout"
      >{{ $t('checkout.basket.checkout') }}</v-btn
    >
  </div>
</template>

<script>
// <BaseButton :disabled="pending" :href="checkoutLink" type="primary">{{
//   $t('checkout.basket.checkout')
// }}</BaseButton>

import { mapActions, mapGetters } from 'vuex'

import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'

import APP_ACTIONS from '@/js/plugins/store/modules/app/action-types.js'
import APP_GETTER from '@/js/plugins/store/modules/app/getter-types.js'
import { toggleHTMLOverflowHidden } from '@/js/helper/dom-helper.js'
/** TODO: Should be refactored */
export default {
  name: 'MiniBasketButtons',
  props: {
    pending: {
      type: Boolean,
      default: false,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters(STOREMODULES.APP, {
      getLinkByType: APP_GETTER.APP_CONFIG_LINK_BY_TYPE,
      isSmWidth: APP_GETTER.IS_SM_WIDTH,
    }),
    checkoutLink() {
      return this.getLinkByType('checkout')
    },
  },
  methods: {
    ...mapActions(STOREMODULES.APP, {
      hideOverlay: APP_ACTIONS.HIDE_OVERLAY,
      hideBasket: APP_ACTIONS.HIDE_BASKET,
    }),
    closeBasket() {
      this.hideOverlay()
      this.hideBasket()
      if (this.isSmWidth) {
        toggleHTMLOverflowHidden()
      }
    },
    goToCheckout() {
      this.$router.push({ name: 'checkout' })
      this.$emit('close')
      this.hideOverlay()
      this.hideBasket()
    },
  },
}
</script>

<style lang="scss" module>
.basket-btn {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    width: auto !important;
    margin: 0;
    padding: 0.75rem 2.5rem !important;

    font-size: 1.25rem !important;
  }
  margin: 0.4rem 0;
  padding: 0.45rem 1.5rem !important;

  font-size: 1.1rem !important;
}

.basket-buttons {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0.9375rem 1.5625rem;
  }
  display: flex;
  // flex-direction: column;
  flex-direction: row;
  justify-content: space-around;
  padding: 0.9375rem 0.5625rem;

  background: var(--white);
}
</style>
